export const GTM_ID = "GTM-W2S8LBDL";
